var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcCloseModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcCloseModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.045031,41.5000305 L339.680009,36.8650473 C340.106664,36.4383915 340.106664,35.7466476 339.680009,35.3200529 C339.253353,34.8933971 338.561671,34.8933971 338.135016,35.3200529 L333.499977,39.9550971 L328.864938,35.3199918 C328.438283,34.8933361 327.746601,34.8933361 327.319946,35.3199918 C326.893351,35.7466476 326.893351,36.4383915 327.319946,36.8649862 L331.954985,41.4999695 L327.319946,46.1350138 C326.893351,46.5616695 326.893351,47.2534134 327.319946,47.6800082 C327.746601,48.1066639 328.438283,48.1066639 328.864938,47.6800082 L333.499977,43.0449639 L338.135016,47.6800082 C338.56161,48.1066639 339.253353,48.1066639 339.680009,47.6800082 C340.106664,47.2533524 340.106664,46.5616695 339.680009,46.1350138 L335.045031,41.5000305 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Whats-new-Copy-3",
    transform: "translate(-327.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "onboardingIcCloseModal",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcCloseModal);
export default __webpack_public_path__ + "static/media/onboardingIcCloseModal.1199a1d2b28a12e520db55c4c2f2112e.svg";
export { ForwardRef as ReactComponent };